import { FilterFormFieldStrategyType } from "@/common/types";
import { eplAccessTechOptions } from "../filter-options";
import biaInterfaceTypeOptions from "../filter-options/biaInterfaceType.options";

const eplFormFilterStrategy: FilterFormFieldStrategyType[] = [
  {
    key: "BandWidth",
    element: {
      inputType: "range",
      label: "BandWidth",
      required: false,
      name: "EPL-bandWidth",
      rangeMax: 10000,
      rangeMin: 0,
    },
  },
  {
    key: "Access Technology",
    element: {
      inputType: "select",
      label: "Access Technology",
      required: false,
      name: "EPL-AccessTechnology",
      rangeMax: 10000,
      rangeMin: 0,
      options: eplAccessTechOptions,
    },
  },
  {
    key: "Interface",
    element: {
      inputType: "checkboxGroup",
      label: "Interface",
      name: "EPL-interface",
      required: false,
      options: biaInterfaceTypeOptions,
    },
  },
  {
    key: "QinQ Supported",
    element: {
      inputType: "select",
      label: "QinQ Supported",
      required: false,
      name: "EPL-qinqSupported",
      rangeMax: 10000,
      rangeMin: 0,
      options: [
        {
          label: "Yes",
          value: "true",
        },
        {
          label: "No",
          value: "false",
        },
      ],
    },
  },
];
export default eplFormFilterStrategy;
